import { type Optional } from '@direct-frontend/stdlib';
import { type OrderPaymentMethod, OrderPaymentMethods } from '../../../api/order';

export const nativePayEnabled = (params: {
    nativePayDisabled: Optional<boolean>;
    yandexPayAvailableForAnonymous: Optional<boolean>;
    loggedIn: boolean;
    paymentMethod: OrderPaymentMethod;
}) => {
    const { nativePayDisabled, paymentMethod, loggedIn, yandexPayAvailableForAnonymous } = params;

    if (nativePayDisabled) {
        return false;
    }

    if (paymentMethod !== OrderPaymentMethods.CARD_ONLINE) {
        return false;
    }

    return Boolean(loggedIn || (!loggedIn && yandexPayAvailableForAnonymous));
};
